import { useEffect, useState, useRef, useLayoutEffect, useCallback } from 'react'

import { PageLink, PageTitle } from '../../_metronic/layout/core'
import { KTCard } from '../../_metronic/helpers'
import { KTCardBody } from '../../_metronic/helpers'
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers'
import { Maintable } from '../tables/Maintable'
import { useMemo } from 'react'
import LoadingBar from 'react-top-loading-bar'
import { useWindowWidth } from '@react-hook/window-size/throttled'
import { useDailymonthlyexpenses, useDailymonthlyexpenses2, useDeleteexpense, useUpdateexpenses } from '../contextProviders/Atomqueryprovider'
import CountUp from 'react-countup'
import '../css/popover.css'
import { Column } from 'react-table'
import { useAuth } from '../../app/modules/auth'
import { ItemsSummary } from '../topdashboard/ItemsSummary'
import { useMutation, useQueryClient } from 'react-query'
import io from 'socket.io-client'

import useAggregatedData from '../helpers/useAggregatedData'
import useDataTrend from '../helpers/useDataTrend'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween';
import { getMonthlyexpenses } from '../apis/Loadalltabledata'
import { Addexpensetype } from './modals/Addexpensetype'
import { Addexpensesmore } from './modals/Addexpensesmore'
import { Updateexpense } from './modals/Updateexpense'
import { Deleteexpense } from './modals/Deleteexpense'
import { useDashboard } from '../contextProviders/Dashboardcontext'
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.extend(isBetween);

const moment = require('moment-timezone')
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const PIC_QUANTITIES = process.env.REACT_APP_QUANTITIES_PICS
// Hook

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/home',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]


const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const socket = io('possocket.27mirrors.com')
const truncate = require('truncate')
const isNegative = (num: any) => Math.sign(num) === -1

const Home = () => {
  const refloadingbar: any = useRef(null)
  const queryClient = useQueryClient()
  const myRefsearch: any = useRef()
  const myRefupdate: any = useRef()
  const myRefexpenses: any = useRef()
  const myRefexpensetype: any = useRef()
  const { currentUser, logout } = useAuth()
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [startlimit, setStartlimit] = useState<number>(0)
  const [modalshowupdate, setModalshowupdate] = useState(false)
  const [modalshowdelete, setModalshowdelete] = useState(false)
  const [statusnow, setStatusnow] = useState<boolean>(false)
  const [statusnow2, setStatusnow2] = useState<boolean>(false)
  const [itemto_order, setItemto_order] = useState<string>('expense_date')
  const [desorasc, setDesorasc] = useState<string>('DESC')
  const [serversort, setServersort] = useState<any>([])
  const [search_item, setSearch_item] = useState<string>('%')
  const [pageCount, setPageCount] = useState<number>(0)
  const { showDashboard, toggleDashboard } = useDashboard();

  const [statedeletingexpense, setStatedeletingexpense] = useState(false)
  const [stateupdatingexpense, setStateupdatingexpense] = useState(false)
  const [expensetodelete, setExpensetodelete] = useState<any>('')
  const [expensetoupdatedata, setExpensetoupdatedata] = useState<any>('')
  const [sumexpensesdatanew, setSumexpensesdatanew] = useState<any>([])
  const [modalshowexpenses, setModalshowexpenses] = useState(false)
  const [modalshowexpensetype, setModalshowexpensetype] = useState(false)
  const [hiddencolumnsmade, setHiddencolumnsmade] = useState<any>(['date_end', 'expenses_info'])
  const onlyWidth = useWindowWidth()
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false)

  const net_expenses_made: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? -1 : 1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_expenses,
      }))
  ).map((x: any) => x.totals_sum)

  const net_expenses_made2: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? 1 : -1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_expenses,
      }))
  ).map((x: any) => x.totals_sum)

  const gross_expenses_made: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? -1 : 1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_expenses,
      }))
  ).map((x: any) => x.totals_sum)

  const gross_expenses_made2: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? 1 : -1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_expenses,
      }))
  ).map((x: any) => x.totals_sum)

  const gross_expenses_made_date: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? -1 : 1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_expenses,
      }))
  ).map((x: any) => x.month)

  const gross_expenses_made_date2: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? 1 : -1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_expenses,
      }))
  ).map((x: any) => x.month + ', ' + x.year)

  const net_expenses_made_date: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? -1 : 1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_expenses,
      }))
  ).map((x: any) => x.month)

  const net_expenses_made_date2: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? 1 : -1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_expenses,
      }))
  ).map((x: any) => x.month + ', ' + x.year)

  const adjustments_made: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? -1 : 1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.adjustments
      }))
  ).map((x: any) => x.totals_sum)

  const adjustments_made2: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? 1 : -1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.adjustments
      }))
  ).map((x: any) => x.totals_sum)

  const adjustments_made_date: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? -1 : 1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.adjustments
      }))
  ).map((x: any) => x.month)

  const adjustments_made_date2: any = useAggregatedData(
    sumexpensesdatanew
      .sort((a: any, b: any) => (a.expense_date > b.expense_date ? 1 : -1))
      .map((item: any) => ({
        expense_date: item.expense_date,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.adjustments
      }))
  ).map((x: any) => x.month + ', ' + x.year)

  const showModaldelete = (x: any) => {
    setModalshowdelete(true)
    setStatedeletingexpense(false)
    setExpensetodelete(x)
  }
  const showModalupdate = (x: any) => {
    setModalshowupdate(true)
    setStateupdatingexpense(false)
    setExpensetoupdatedata(x)
    myRefupdate.current.Resetmodalupdatevalues()
  }

  const { mutateAsync: deleteexpensesmutateAsync } = useDeleteexpense(
    expensetodelete.expense_id
  )


  const {
    isLoading: dailymonthlyexpensesisloading,
    isSuccess: dailymonthlyexpensesssuccess,
    data: dailymonthlyexpensesdata,
    isPreviousData: dailymonthlyexpensesispreviousdata,
    status: dailymonthlyexpensesstatus,
    refetch: dailymonthlyexpensesrefetch,
    isRefetching: dailymonthlyexpensesrefetching,
  } = useDailymonthlyexpenses(
    Number(currentUser?.user_id),
    startlimit,
    paginationsize,
    new Date(dayjs
      .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    new Date(dayjs
      .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    itemto_order,
    desorasc,
    search_item
  )

  const {
    isLoading: dailymonthlyexpensesisloading2,
    isSuccess: dailymonthlyexpensesssuccess2,
    data: dailymonthlyexpensesdata2,
    isPreviousData: dailymonthlyexpensesispreviousdata2,
    status: dailymonthlyexpensesstatus2,
    isRefetching: dailymonthlyexpensesrefetching2,
    refetch: dailymonthlyexpensesrefetch2,
  } = useDailymonthlyexpenses2(
    Number(currentUser?.user_id),
    0,
    366,
    new Date(dayjs
      .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    new Date(dayjs
      .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    'expense_date',
    'DESC',
    '%'
  )

  const showModalexpenses = () => {
    setModalshowexpenses(true)
    myRefexpenses.current.Resetmodalexpensesvalues()
  }

  const showModalexpensetype = () => {
    setModalshowexpensetype(true)
    // myRefexpenses.current.Resetmodalexpensetypevalues()
  }

  const tabledata = useMemo(
    () => dailymonthlyexpensesdata?.data.dailymonthlyexpenses,
    [dailymonthlyexpensesdata?.data.dailymonthlyexpenses, dailymonthlyexpensesssuccess]
  )


  const tabledata3 = useMemo(
    () => dailymonthlyexpensesdata2?.data.dailymonthlyexpenses,
    [dailymonthlyexpensesdata2?.data.dailymonthlyexpenses, dailymonthlyexpensesssuccess2]
  )
  const tabledatalength = useMemo(
    () => dailymonthlyexpensesdata?.data.datalength,
    [dailymonthlyexpensesdata?.data.datalength, dailymonthlyexpensesssuccess]
  )

  const tablename = 'Expenses Summary'

  const filteredsubdata = (rowdata: any): number => {

    return rowdata.values.expenses_info.length;
  }
  const filteredtablesubData = (rowdata: any): any => {
    return rowdata.values.expenses_info.sort((a: any, b: any) => (a.date_expense_made > b.date_expense_made ? -1 : 1))
  }

  const expenseTrend = useDataTrend(tabledata3)

  useEffect(() => {
    if (!dailymonthlyexpensesrefetching2 && dailymonthlyexpensesssuccess2) {
      if (
        dayjs(
          dayjs(
            dailymonthlyexpensesdata2?.data.dailymonthlyexpenses
              .sort((a: any, b: any) => (a.expense_date > b.expense_date ? -1 : 1))
              .map((x: any) => x.expense_date)[0]
          ).format('YYYY-MM-DD')
        ).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()
      ) {
        setSumexpensesdatanew(dailymonthlyexpensesdata2?.data.dailymonthlyexpenses)
      } else {
        if (
          dayjs(
            dayjs(
              dailymonthlyexpensesdata2?.data.dailymonthlyexpenses
                .sort((a: any, b: any) => (a.expense_date > b.expense_date ? -1 : 1))
                .map((x: any) => x.expense_date)[0]
            ).format('YYYY-MM-DD')
          ).unix() === dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix() &&
          dayjs(dayjs().format('YYYY-MM-DD, h:mm:ss a')).unix() <=
          dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix()
        ) {
          setSumexpensesdatanew(dailymonthlyexpensesdata2?.data.dailymonthlyexpenses)
        } else {
          const currentitemsobj2: any = {
            expense_date: dayjs().format('YYYY-MM-DD'),
            date_start: dayjs().format('YYYY-MM-DD'),
            date_end: dayjs().format('YYYY-MM-DD'),
            occurrences: 0,
            hours_selling: 0,
            net_expenses: 0,
            gross_expenses: 0,
            adjustments: 0
          }

          setSumexpensesdatanew([
            ...dailymonthlyexpensesdata2?.data.dailymonthlyexpenses,
            currentitemsobj2,
          ])
        }
      }
    }
  }, [dailymonthlyexpensesssuccess2, dailymonthlyexpensesrefetching2])

  useEffect(() => {
    if (dailymonthlyexpensesssuccess2) {
      setStatusnow(true)
    } else {
      setStatusnow(false)
    }
  }, [dailymonthlyexpensesssuccess2])

  useEffect(() => {
    if (statusnow && !dailymonthlyexpensesrefetching2) {
      setStatusnow2(true)
    } else {
      setStatusnow2(false)
    }
  }, [dailymonthlyexpensesrefetching2])

  useEffect(() => {
    if (!dailymonthlyexpensesispreviousdata) {
      ; (async () => {
        await refloadingbar.current?.continuousStart()
        queryClient.prefetchQuery(
          ['dailymonthlyexpenses', startlimit + paginationsize, paginationsize],
          () =>
            getMonthlyexpenses(
              Number(currentUser?.user_id),
              startlimit + paginationsize,
              paginationsize,
              new Date(dayjs
                .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
                .format('YYYY-MM-DD hh:mm')),
              new Date(dayjs
                .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
                .format('YYYY-MM-DD hh:mm')),
              itemto_order,
              desorasc,
              search_item
            )
        )
      })().finally(() => refloadingbar.current?.complete())
    }
  }, [
    dailymonthlyexpensesispreviousdata,
    startlimit,
    paginationsize,
    queryClient,
    itemto_order,
    desorasc,
    search_item,
  ])


  socket.on('update', (_arg: any) => {
    ; (async () => {
      try {
        await refloadingbar.current?.continuousStart()
        await dailymonthlyexpensesrefetch2()
        await dailymonthlyexpensesrefetch()

      } catch (error) {
        console.log(error)
      } finally {
        await refloadingbar.current?.complete()
      }
    })()
  })

  useEffect(() => {
    const fetchData = async () => {
      try {
        await refloadingbar.current?.continuousStart();
        await dailymonthlyexpensesrefetch();
      } catch (error) {
        console.log(error)
      } finally {
        refloadingbar.current?.complete();
      }
    };
    fetchData();
  }, [itemto_order, desorasc, search_item]);


  useEffect(() => {
    const handleValueChange = () => {
      if (myRefsearch.current.value === '' && myRefsearch.current === document.activeElement) {
        setSearch_item('%')
        setPaginationsize(10)
        setStartlimit(0)
        setMovetofirstpage(true)
        setItemto_order('expense_date')
        setDesorasc('DESC')
      }
    }




    const refSearch = myRefsearch.current;
    if (refSearch) {
      refSearch.addEventListener('input', handleValueChange);
    }

    return () => {
      if (refSearch) {
        refSearch.removeEventListener('input', handleValueChange);
      }
    }
  }, []);

  useEffect(() => {
    if (serversort.length > 0) {
      setItemto_order(serversort.map((x: any) => x.id)[0])
      setDesorasc(serversort.map((x: any) => x.desc)[0] ? 'DESC' : 'ASC')
    } else {
      setItemto_order('expense_date')
      setDesorasc('DESC')
    }
  }, [serversort])

  const handlesearchKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      const inputValue = event.target.value;
      if (inputValue) {
        setSearch_item(inputValue + '%');
      } else {
        setSearch_item('%');
      }
      setPaginationsize(10)
      setStartlimit(0)
      setMovetofirstpage(true)
      setItemto_order('expense_date')
      setDesorasc('DESC')
    }
  };

  const handleinputs = (event: any) => {
    if (myRefsearch.current.value === '' || event.target.value === '') {
      setSearch_item('%')
      setPaginationsize(10)
      setStartlimit(0)
      setMovetofirstpage(true)
      setItemto_order('expense_date')
      setDesorasc('DESC')
    }
  }


  const deleteexpenses = async () => {
    setStatedeletingexpense(true)

    deleteexpensesmutateAsync(expensetodelete.expense_id, {
      onSuccess: () => {
        setStatedeletingexpense(false)
        setModalshowdelete(false)
      },
      onError(error, _variables, _context) {
        console.log(error)
        setStatedeletingexpense(true)
        setModalshowdelete(false)
      },
    })
  }





  const handlesearchKeyDown2 = (event: any) => {
    event.preventDefault()
    const inputValue = myRefsearch.current.value || event.target.value;

    if (inputValue) {
      setSearch_item(inputValue + '%');
    } else {
      setSearch_item('%');
    }

    setPaginationsize(10)
    setStartlimit(0)
    setMovetofirstpage(true)
    setItemto_order('expense_date')
    setDesorasc('DESC')
  }

  const columndata1: ReadonlyArray<
    Column<{
      expense_date: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      net_expenses: number
      gross_expenses: number
      expense_trend: number
      expenses_info: Array<number | string>
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Date',
        accessor: 'date_start', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-60px me-5'>
                <span className='svg-icon svg-icon-primary svg-icon-3x'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='21'
                    fill='none'
                    viewBox='0 0 20 21'
                  >
                    <path
                      fill='currentColor'
                      d='M19 3.4c-.6 0-1 .4-1 1v4h-4v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H8v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H2v-4c0-.6-.4-1-1-1s-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-15c0-.6-.4-1-1-1zm-1 7v3h-4v-3h4zm-6 0v3H8v-3h4zm0 5v3H8v-3h4zm-6-5v3H2v-3h4zm-4 5h4v3H2v-3zm12 3v-3h4v3h-4z'
                      opacity='0.3'
                    ></path>
                    <path
                      fill='currentColor'
                      d='M19 .4H1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1z'
                    ></path>
                  </svg>
                </span>
              </div>

              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                  {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
                  {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
                </span>
                <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                  {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
                </span>
              </div>
            </div>
          )
        },
      },

      {
        Header: 'E.Sales',
        accessor: 'date_end',

        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },

      {
        Header: 'Entries',
        accessor: 'occurrences',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {row.original.hours_selling} Hours
            </span>
          </>
        ),
      },
      {
        Header: 'expenses_info',
        accessor: 'expenses_info',

      },
      {
        Header: 'G.Expenses',
        accessor: 'gross_expenses',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              <>
                {isNegative(value) ? (
                  <span className='text-danger'>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                ) : (
                  <span>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}{' '}
                  </span>
                )}
              </>
            </span>
            <span className='text-nowrap fw-bold text-muted d-block fs-7'>
              <span className='badge badge-light-danger'>
                {addCommas(row.original.gross_expenses.toFixed(2))} {CURRENCY_APP}
              </span>
            </span>
          </>
        ),
      },
      {
        Header: 'N.Expenses',
        accessor: 'net_expenses',

        Cell: ({ cell: { value }, row }) => (
          <>
            {isNegative(value) ? (
              <span className='text-nowrap'>
                {!isNegative(row.original.expense_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.expense_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-success'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            ) : (
              <span className='text-nowrap'>
                {!isNegative(row.original.expense_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.expense_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-danger'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            )}
          </>
        ),
      },
    ]
  const columndata2: ReadonlyArray<
    Column<{
      expense_id: number
      expense_amount: number
      expense_name: string
      date_expense_made: string
      expense_type_id: number
    }>
  > = [
      {
        Header: 'id',
        accessor: 'expense_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
          </>
        ),
      },

      {
        Header: 'Date',
        accessor: 'date_expense_made',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },
      {
        Header: 'Name',
        accessor: 'expense_name',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.expense_name}>
              {truncate(row.original.expense_name, 20)}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              TYPE : {row.original.expense_type_id}
            </span>
          </>
        ),
      },

      {
        Header: 'Amount',
        accessor: 'expense_amount',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {' '}
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
          </>
        ),
      },
      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => {
          return (
            <div className='d-flex justify-content-end flex-shrink-0'>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
                onClick={() => showModalupdate(row.original)}
              >
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      opacity='0.3'
                      d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                      fill='black'
                    ></path>
                    <path
                      d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                      fill='black'
                    ></path>
                  </svg>
                </span>
              </a>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                onClick={() => showModaldelete(row.original)}
              >
                {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={24}
                    height={24}
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                      fill='#f1416c'
                    />
                  </svg>
                </span>
                {/*end::Svg Icon*/}
              </a>
            </div>
          )
        },
      }
    ]

  // less than 420

  const columndata3: ReadonlyArray<
    Column<{
      expense_date: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      net_expenses: number
      gross_expenses: number
      expense_trend: number
      expenses_info: Array<number | string>
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Date',
        accessor: 'date_start', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                  {dayjs(value).format('MMM')} {dayjs(value).format('DD')} -{' '}
                  {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
                </span>
                <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                  {dayjs(value).format('LT')} - {dayjs(row.original.date_end).format('LT')}
                </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'E.Sales',
        accessor: 'date_end',

        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },
      {
        Header: 'expenses_info',
        accessor: 'expenses_info',

      },

      {
        Header: 'N.Expenses',
        accessor: 'net_expenses',

        Cell: ({ cell: { value }, row }) => (
          <>
            {isNegative(value) ? (
              <>
                <span className='text-nowrap'>
                  {!isNegative(row.original.expense_trend) ? (
                    <i className='fa fa-arrow-down text-danger'></i>
                  ) : row.original.expense_trend === 0 ? (
                    <i className='fa fa-arrow-up text-primary'></i>
                  ) : (
                    <i className='fa fa-arrow-up text-success'></i>
                  )}{' '}
                  <span className='badge badge-light-success'>
                    <span className='text-nowrap fs-7'>
                      {' '}
                      {addCommas(value.toFixed(2))} {CURRENCY_APP}
                    </span>
                  </span>
                </span>
              </>
            ) : (
              <>
                <span className='text-nowrap'>
                  {!isNegative(row.original.expense_trend) ? (
                    <i className='fa fa-arrow-down text-danger'></i>
                  ) : row.original.expense_trend === 0 ? (
                    <i className='fa fa-arrow-up text-primary'></i>
                  ) : (
                    <i className='fa fa-arrow-up text-success'></i>
                  )}{' '}
                  <span className='badge badge-light-danger'>
                    <span className='text-nowrap fs-7'>
                      {' '}
                      {addCommas(value.toFixed(2))} {CURRENCY_APP}
                    </span>
                  </span>
                </span>
              </>
            )}
          </>
        ),
      },
    ]

  const columndata4: ReadonlyArray<
    Column<{
      expense_id: number
      expense_amount: number
      expense_name: string
      date_expense_made: string
      expense_type_id: number
    }>
  > = [
      {
        Header: 'Name',
        accessor: 'expense_name',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.expense_name}>
              {truncate(row.original.expense_name, 20)}
            </span>

            <span className='text-muted text-nowrap d-block mb-1 fs-7'>
              {addCommas(row.original.expense_amount.toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              TYPE : {row.original.expense_type_id}
            </span>
          </>
        ),
      },
      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => {
          return (
            <div className='d-flex justify-content-end flex-shrink-0'>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
                onClick={() => showModalupdate(row.original)}
              >
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      opacity='0.3'
                      d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                      fill='black'
                    ></path>
                    <path
                      d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                      fill='black'
                    ></path>
                  </svg>
                </span>
              </a>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                onClick={() => showModaldelete(row.original)}
              >
                {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={24}
                    height={24}
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                      fill='#f1416c'
                    />
                  </svg>
                </span>
                {/*end::Svg Icon*/}
              </a>
            </div>
          )
        },
      }
    ]

  //less than 420

  //less than 730 but more than 420
  const columndata5: ReadonlyArray<
    Column<{
      expense_date: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      net_expenses: number
      gross_expenses: number
      expense_trend: number
      expenses_info: Array<number | string>
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Date',
        accessor: 'date_start', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-60px me-5'>
                <span className='svg-icon svg-icon-primary svg-icon-3x'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='21'
                    fill='none'
                    viewBox='0 0 20 21'
                  >
                    <path
                      fill='currentColor'
                      d='M19 3.4c-.6 0-1 .4-1 1v4h-4v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H8v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H2v-4c0-.6-.4-1-1-1s-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-15c0-.6-.4-1-1-1zm-1 7v3h-4v-3h4zm-6 0v3H8v-3h4zm0 5v3H8v-3h4zm-6-5v3H2v-3h4zm-4 5h4v3H2v-3zm12 3v-3h4v3h-4z'
                      opacity='0.3'
                    ></path>
                    <path
                      fill='currentColor'
                      d='M19 .4H1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1z'
                    ></path>
                  </svg>
                </span>
              </div>

              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                  {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
                  {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
                </span>
                <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                  {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
                </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'E.Sales',
        accessor: 'date_end',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
              {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
            </span>
          </>
        ),
      },
      {
        Header: 'Entries',
        accessor: 'occurrences',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {row.original.hours_selling} Hours
            </span>
          </>
        ),
      },
      {
        Header: 'expenses_info',
        accessor: 'expenses_info',

      },

      {
        Header: 'G.Expenses',
        accessor: 'gross_expenses',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              <>
                {isNegative(value) ? (
                  <span className='text-danger'>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                ) : (
                  <span>
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}{' '}
                  </span>
                )}
              </>
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              <span className='badge badge-light-danger'>
                {addCommas(row.original.gross_expenses.toFixed(2))} {CURRENCY_APP}
              </span>
            </span>
          </>
        ),
      },
      {
        Header: 'N.Expenses',
        accessor: 'net_expenses',

        Cell: ({ cell: { value }, row }) => (
          <>
            {isNegative(value) ? (
              <span className='text-nowrap'>
                {!isNegative(row.original.expense_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.expense_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-success'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            ) : (
              <span className='text-nowrap'>
                {!isNegative(row.original.expense_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.expense_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-danger'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            )}
          </>
        ),
      },
    ]
  const columndata6: ReadonlyArray<
    Column<{
      expense_id: number
      expense_amount: number
      expense_name: string
      date_expense_made: string
      expense_type_id: number
    }>
  > = [
      {
        Header: 'id',
        accessor: 'expense_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
          </>
        ),
      },

      {
        Header: 'Date',
        accessor: 'date_expense_made',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },
      {
        Header: 'Name',
        accessor: 'expense_name',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.expense_name}>
              {truncate(row.original.expense_name, 20)}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              TYPE : {row.original.expense_type_id}
            </span>
          </>
        ),
      },
      {
        Header: 'Amount',
        accessor: 'expense_amount',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {' '}
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
          </>
        ),
      },
      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => {
          return (
            <div className='d-flex justify-content-end flex-shrink-0'>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
                onClick={() => showModalupdate(row.original)}
              >
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      opacity='0.3'
                      d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                      fill='black'
                    ></path>
                    <path
                      d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                      fill='black'
                    ></path>
                  </svg>
                </span>
              </a>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                onClick={() => showModaldelete(row.original)}
              >
                {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={24}
                    height={24}
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                      fill='#f1416c'
                    />
                  </svg>
                </span>
                {/*end::Svg Icon*/}
              </a>
            </div>
          )
        },
      }
    ]

  //less than 730 but more than 420

  return (
    <>
      <LoadingBar color='#009ef7' ref={refloadingbar} />
      <PageTitle breadcrumbs={usersBreadcrumbs}>Expenses</PageTitle>
      {/* begin::Row */}
      {/* begin::Row */}
      {showDashboard && (
        <div className='row g-5 g-xl-8'>
          {/* begin::Col */}

          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='120px'
              cardName='G.Expenses'
              chartName='Gross Expenses'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={
                Math.abs(Math.max(...gross_expenses_made))
              }
              chartCategories={gross_expenses_made_date2}
              chartData={gross_expenses_made2}
              values={
                <>
                  <div className='fs-2 fw-bolder d-block '>
                    <CountUp
                      className='text-primary'
                      end={gross_expenses_made[0]}
                      duration={2}
                      decimals={2}
                      separator=','
                    />{' '}
                    <sup className='fs-6 text-primary'>{CURRENCY_APP}</sup>
                  </div>
                </>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {gross_expenses_made[1] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-primary'>
                                {gross_expenses_made_date[1]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={gross_expenses_made[1]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        {gross_expenses_made[2] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-primary'>
                                {gross_expenses_made_date[2]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={gross_expenses_made[2]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>
          {/* end::Col */}

          {/* begin::Col */}
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='danger'
              chartHeight='120px'
              cardName='Adjust.'
              chartName='Adjustments'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={
                Math.abs(Math.max(...adjustments_made))
              }
              chartCategories={adjustments_made_date2}
              chartData={adjustments_made2}
              values={
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className='text-danger'
                    end={adjustments_made[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='text-danger fs-6'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {adjustments_made[1] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-danger'>
                                {adjustments_made_date[1]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={adjustments_made[1]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        {adjustments_made[2] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-danger'>
                                {adjustments_made_date[2]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={adjustments_made[2]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>
          {/* end::Col */}

          {/* begin::Col */}
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-5 mb-xl-8'
              chartColor={`${isNegative(net_expenses_made[0]) ? 'danger' : 'success'}`}
              chartHeight='120px'
              statusnow={statusnow}
              statusnow2={statusnow2}
              cardName={`N.Expenses`}
              chartName={`Net Expenses`}
              yaxisHeight={
                Math.abs(Number(Math.max(...net_expenses_made).toFixed(0)))}
              chartCategories={net_expenses_made_date2}
              chartData={net_expenses_made2}
              values={
                <>
                  <div className='fs-2 fw-bolder'>
                    <CountUp
                      className={`${isNegative(net_expenses_made[0]) ? 'text-danger' : 'text-success'}`}
                      end={net_expenses_made[0]}
                      duration={2}
                      decimals={2}
                      separator=','
                    />{' '}
                    <sup
                      className={`${isNegative(net_expenses_made[0]) ? 'fs-6 text-danger' : 'fs-6 text-success'
                        }`}
                    >
                      {CURRENCY_APP}
                    </sup>
                  </div>
                </>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {net_expenses_made[1] ? (
                          <tr>
                            <td>
                              <span
                                className={`${isNegative(net_expenses_made[1])
                                    ? 'badge badge-light-danger'
                                    : 'badge badge-light-success'
                                  }`}
                              >
                                {net_expenses_made_date[1]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={net_expenses_made[1]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        {net_expenses_made[2] ? (
                          <tr>
                            <td>
                              <span
                                className={`${isNegative(net_expenses_made[2])
                                    ? 'badge badge-light-danger'
                                    : 'badge badge-light-success'
                                  }`}
                              >
                                {net_expenses_made_date[2]}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={net_expenses_made[2]}
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>
          {/* end::Col */}
        </div>
      )}
      {/* end::Row */}

      <KTCard>
        <KTCardBody className='py-4'>
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2'>
                <h3 className='fw-bolder my-2'>Daily Expenses</h3>
              </div>
            </div>
            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                {/* begin::Search */}
                <div className='d-flex align-items-center position-relative my-1'>
                  <a href='#' onClick={handlesearchKeyDown2}>
                    <KTSVG
                      path='/media/icons/duotune/general/gen021.svg'
                      className='svg-icon-1 position-absolute me-4 top-0 end-0 mt-3 text-primary'
                    />
                  </a>
                  <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-250px ps-14'
                    placeholder='Search Items'
                    ref={myRefsearch}
                    // value={searchTitle}
                    onChange={handleinputs}
                    onKeyDown={handlesearchKeyDown}
                  />
                </div>
                {/* end::Search */}
              </div>
            </div>
          </div>

          <div className='row mt-5 mb-5'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>

            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                <div className='d-flex align-items-center text-nowrap'>
                  <span className='text-muted fw-bolder fs-7 text-uppercase gs-0'>INSIGHTS</span>
                  <span className='h-50px border-gray-200 border-start mx-2'></span>
                  <div className='d-flex justify-content-start flex-column'>
                    <span className='fw-bold d-block fs-7 text-muted'>
                      <table>
                        <tbody>
                          {expenseTrend.direction ? (
                            <tr>
                              <td>NE.TREND</td>
                              <td>
                                <span className='h-20px border-gray-200 border-start mx-2'></span>
                                <span className={`${expenseTrend.direction === "downward" ? "text-success" : "text-danger"}`}>
                                  <span className='text-uppercase fw-bolder'>
                                    {expenseTrend.direction}
                                  </span>{' '}
                                </span>
                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}

                          {dailymonthlyexpensesssuccess2 ? (
                            <tr>
                              <td>NE.AVERAGE</td>
                              <td>
                                <span className='h-20px border-gray-200 border-start mx-2'></span>
                                <span className='text-uppercase fw-bolder'>
                                  <CountUp
                                    className='text-primary'
                                    end={
                                      Number(
                                        tabledata3.reduce(
                                          (acc: any, curr: any) => acc + curr.net_expenses,
                                          0
                                        )
                                      ) / tabledata3.length
                                    }
                                    duration={2}
                                    decimals={2}
                                    separator=','
                                  />{' '}
                                  <sup>{CURRENCY_APP}</sup>
                                </span>
                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}
                        </tbody>
                      </table>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-md-5 col-xxl-12 d-flex align-items-center justify-content-center justify-content-md-start'></div>

            <div className='col-sm-12 col-md-7 col-xxl-12 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                {/* begin::Search */}
                <div className='col-sm-12 col-md-12 d-flex align-items-center justify-content-center justify-content-md-end'>
                  <div className='mb-2' style={{ display: 'inline-grid', gridTemplateColumns: '1fr 1fr' }}>
                    {/* buying buttons */}

                    <a
                      className='btn btn-info btn-sm me-2 mb-2 text-nowrap'
                      href='#'
                      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                        e.preventDefault();
                        showModalexpensetype();
                      }}
                      title={onlyWidth <= 576 ? 'Add Type' : ''}
                    >
                      <KTSVG
                        path='/media/icons/duotune/general/gen055.svg'
                        className='svg-icon-1'
                      />
                      {onlyWidth <= 576 ? '+' : 'Add Type'}
                    </a>

                    <a
                      className='btn btn-danger btn-sm me-2 mb-2 text-nowrap'
                      href='#'
                      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                        e.preventDefault();
                        showModalexpenses();
                      }}
                      title={onlyWidth <= 576 ? 'Add Expense' : ''}
                    >
                      <KTSVG
                        path='/media/icons/duotune/finance/fin008.svg'
                        className='svg-icon-1'
                      />
                      {onlyWidth <= 576 ? '+' : 'Add Expense'}
                    </a>

                    {/* buying buttons */}
                  </div>
                </div>
                {/* end::Search */}
              </div>
            </div>
          </div>
          <Maintable
            tabledata={dailymonthlyexpensesssuccess ? tabledata : []}
            startlimit={startlimit}
            hiddencolumnsmade={hiddencolumnsmade}
            movetofirstpage={movetofirstpage}
            setMovetofirstpage={setMovetofirstpage}
            setstartlimit={setStartlimit}
            paginationsize={paginationsize}
            pageCount={pageCount}
            setPageCount={setPageCount}
            setPaginationsize={setPaginationsize}
            columndata={
              onlyWidth <= 576
                ? columndata3
                : onlyWidth > 576 && onlyWidth <= 768
                  ? columndata5
                  : columndata1
            }
            tabledata2={tabledata}
            columndata2={
              onlyWidth <= 576
                ? columndata4
                : onlyWidth > 576 && onlyWidth <= 768
                  ? columndata6
                  : columndata2
            }
            table1loaded={dailymonthlyexpensesstatus === 'success'}
            table2loaded={dailymonthlyexpensesstatus === 'success'}
            tablename={tablename}
            tablelength={dailymonthlyexpensesstatus === 'success' ? tabledatalength : 0}
            filteredsubdata={filteredsubdata}
            filteredtablesubData={filteredtablesubData}
            setServersort={setServersort}
          />
        </KTCardBody>
      </KTCard>
      <Addexpensesmore
        show={modalshowexpenses}

        handleClose={function (): void {
          setModalshowexpenses(false)
        }}
        ref={myRefexpenses}
      />

      <Addexpensetype
        show={modalshowexpensetype}

        handleClose={function (): void {
          setModalshowexpensetype(false)
        }}
        ref={myRefexpensetype}
      />

      <Deleteexpense
        show={modalshowdelete}
        deleteexpenses={deleteexpenses}
        expensetodelete={expensetodelete}
        statedeletingexpense={statedeletingexpense}
        handleClose={function (): void {
          setModalshowdelete(false)
        }}
      />

      <Updateexpense
        show={modalshowupdate}
        expensetoupdatedata={expensetoupdatedata}
        stateupdatingexpense={stateupdatingexpense}
        handleClose={function (): void {
          setModalshowupdate(false)
        }}
        ref={myRefupdate}
      />
    </>
  )
}

export default Home